import React, { Component } from 'react';
import PropTypes from 'prop-types';
import '../../styles/core.scss';
import css from './library-item.scss';
import loader from '../../assets/images/loading.gif';

class LibraryItem extends Component {
	constructor(props) {
		super(props);
		this.state = { imageLoading: true };
	}

	handleImageLoaded() {
		this.setState({ imageLoading: false });
	}

	render() {
		const { itemId, grade, title, itemType, thumbnailUrl, callbackOnClick } = this.props;

		return (
			<div className={css.component} id={itemId} tabIndex="0" role="button" onClick={callbackOnClick}>
				{ this.state.imageLoading ? <img src={loader} width="120" height="120" alt="loading..." /> : null }
				<img className={css.thumb} src={thumbnailUrl} alt={title} onLoad={() => this.handleImageLoaded()} />
				<div className={css.itemInfo}>
					{grade}<br />
					<b>{title}</b><br />
					{itemType}
				</div>
			</div>
		);
	}
}

LibraryItem.propTypes = {
	itemId: PropTypes.number,
	grade: PropTypes.string,
    title: PropTypes.string,
    itemType: PropTypes.string,
	thumbnailUrl: PropTypes.string,
    callbackOnClick: PropTypes.func
};

export default LibraryItem;
